import React, { useContext, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import languages from "common/languages";
import { FlagContext } from "libs/context/FlagContext";

const LanguageDropdown = () => {
  const [menu, setMenu] = useState(false);
  const { selectedLang, updateLang } = useContext(FlagContext);

  const toggle = () => setMenu(!menu);

  return (
    <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
      <DropdownToggle className="btn header-item" tag="button">
        <img
          src={get(languages, `${selectedLang}.flag`)}
          alt="flag"
          height="16"
          className="me-1"
        />
      </DropdownToggle>

      <DropdownMenu className="language-switch dropdown-menu-end">
        {map(Object.keys(languages), (key) => (
          <DropdownItem
            key={key}
            onClick={() => updateLang(key)}
            className={`notify-item ${selectedLang === key ? "active" : ""}`}
          >
            <img
              src={get(languages, `${key}.flag`)}
              alt="flag"
              className="me-1"
              height="12"
            />
            <span className="align-middle">{get(languages, `${key}.label`)}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageDropdown;
